<template>
  <b-container fluid>
    <lca-detail-header lca="폐기"
                       :total="total"
                       :total-per-production="totalPerProduction"
                       :rank="rank"/>

    <disposal-detail :product="product"
                     :year="year"
                     class="mt-3"
                     @totalCalculated="onTotalCalculated"/>

    <b-row class="mt-5">
      <b-col lg="6">
        <b class="content-title">폐기물별 배출 비율</b>
        <product-disposal-emission-by-waste :product="product"
                                            :year="year"/>
      </b-col>
      <b-col lg="6"
             class="mt-5 mt-lg-0">
        <b class="content-title">배출활동별 배출 비율</b>
        <product-disposal-emission-by-activity :product="product"
                                               :year="year"/></b-col>
    </b-row>
  </b-container>
</template>
<script>
import DisposalDetail from "../tables/DisposalDetail.vue";
import ProductDisposalEmissionByWaste from "../charts2/ProductDisposalEmissionByWaste.vue";
import ProductDisposalEmissionByActivity from "../charts2/ProductDisposalEmissionByActivity.vue";
import LcaDetailHeader from "@/components/esg/3. Monitoring/3.2. LCA 배출량 관리/3.2.1. 제품별/LcaDetailHeader.vue";

export default {
  // 폐기 상세
  components: {LcaDetailHeader, DisposalDetail, ProductDisposalEmissionByWaste, ProductDisposalEmissionByActivity },
  props: {
    year: {
      type: Number
    },
    product: {
      type: Object,
    },
  },
  watch: {
    product: {
      immediate: true,
      deep: true,
      handler() {
        this.fetchRanks()
      }
    },
    year: {
      immediate: true,
      handler() {
        this.fetchRanks()
      }
    }
  },
  computed: {
    lca() {
      return this.$store.getters['ghg/lifeCycleStages'];
    },
    formattedRank() {
      if (!this.rank || !this.rank.rank || !this.rank.count) return null
      return `(${this.rank.rank}/${this.rank.count})`
    }
  },
  beforeDestroy() {
    if (this.abortController) {
      this.abortController.abort();
    }
  },
  methods: {
    async fetchRanks() {
      if (!this.product || !this.product.productFamilyCode || !this.product.productCode || !this.product.name) return
      if (!this.year) return;

      try {
        this.loading = true;

        let args = [{
          years: [this.year],
          productFamilies: [this.product.productFamilyCode],
          products: [this.product.productCode],
          categories: [this.lca[5].value]
        }];

        let data = new FormData()
        data.append('path', 'esg/lca/rank/main');
        data.append('json', JSON.stringify(args));

        this.abortController = new AbortController();
        let response = await axios.post('esg/lca/run/python/chart-data', data, {
          headers: { Authorization: accessToken() },
          signal: this.abortController.signal
        });

        // If there is no data, return
        if (!response.data.data){
          this.rank =  { rank: null, count: null }
          return
        }

        // Parse JSON data
        this.rank = JSON.parse(response.data.data)[0].data[0];
      } catch (error) {
        await this.showError(error)
      }
    },
    onTotalCalculated(total, totalPerProduction) {
      this.total = total;
      this.totalPerProduction = totalPerProduction
    }
  },
  data() {
    return {
      total: 0,
      totalPerProduction: 0,
      rank: { rank: 0, count: 0 }
    }
  },
}
</script>
